export interface ITerminalErrorEntry {
	detail: string;
	code: string;
}

export const TERMINAL_ERROR_CODES = {
	APP_TERMINAL_PENDING: "APP_TERMINAL_PENDING",
	APP_TERMINAL_NOT_FOUND: "APP_TERMINAL_NOT_FOUND",
	APP_TERMINAL_ERROR: "APP_TERMINAL_ERROR",
	APP_DUPLICATE_PAYMENT_ATTEMPT: "APP_DUPLICATE_PAYMENT_ATTEMPT",
} as const;

export type TerminalErrorCode = (typeof TERMINAL_ERROR_CODES)[keyof typeof TERMINAL_ERROR_CODES];

interface ITerminalErrorData {
	error?: string;
	errors?: ITerminalErrorEntry[];
}

export function parseTerminalError(
	data: ITerminalErrorData
): { detail: string; code?: string } | null {
	if (data.errors?.length) {
		return { detail: data.errors[0].detail, code: data.errors[0].code };
	}
	if (data.error) {
		return { detail: data.error };
	}

	return null;
}
